export function calculateNetCost(pricePerUnit, numberOfItems) {
    return pricePerUnit * numberOfItems;
}
export function calculateGrossCost(pricePerUnit, numberOfItems, markupFactor) {
    return Number((pricePerUnit * numberOfItems * (1 + markupFactor / 100)).toFixed(4));
}
